import { h } from 'preact';
import * as BaseComp from 'components/bolt/footer/footer.js';

import { geoFromIP } from 'utils/bolt/geo';
import { isInEU } from 'utils/eu';

import s from 'components/bolt/footer/footer.sss';

export default class Footer extends BaseComp.default {
	async componentDidMount() {
		super.componentDidMount();
		const geo = await geoFromIP();
		const userInEU = await isInEU(geo?.countryCode);
		this.setState({ userCountry: geo?.countryCode, userInEU });
	}

	renderDoNotSellLogo() {
		const imageRoot = this.props.store?.appData?.urls?.roots?.studio || '';
		return <img class={s.doNotSellLogo} src={imageRoot + '/images/ccpa-icon/privacyoptions.svg'} alt="California Consumer Privacy Act (CCPA) Opt-Out Icon" />;
	}

	getLinkContent(link, type) {
		const base = super.getLinkContent(link, type);
		if (type === 'logo') return base;
		return [
			link.showPrivacyChoicesLogo && this.renderDoNotSellLogo(),
		].concat(base).filter(e => e);
	}

	renderLinks(items, type) {
		const { userInEU, userCountry } = this.state;
		if (!userInEU) {
			items = Object.fromEntries(Object.entries(items || {}).filter(([key]) => key !== 'cookies'));
		}
		if (userCountry === 'us') {
			items = Object.fromEntries(Object.entries(items || {}).filter(([key, val]) => !val.nonUsOnly));
		} else {
			items = Object.fromEntries(Object.entries(items || {}).filter(([key, val]) => !val.usOnly));
		}

		return super.renderLinks(items, type);
	}
}